import React, { createRef } from 'react';
import './styles/index.scss';
type PDFFrameProps = {
  pdfContent: CMxAPI.HtmlDoc;
};

const base64toBlob = data => {
  const bytes = window.atob(data);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: 'application/pdf' });
};

class PDFFrame extends React.Component<PDFFrameProps> {
  _iframeRef: React.RefObject<HTMLIFrameElement>;

  constructor(props: PDFFrameProps) {
    super(props);
    this._iframeRef = createRef();
  }

  componentDidMount() {
    this.updateIframeContent();
  }

  componentDidUpdate(prevProps: PDFFrameProps) {
    if (this.props.pdfContent.id !== prevProps.pdfContent.id) {
      this.updateIframeContent();
    }
  }

  updateIframeContent() {
    const { pdfContent: iframeNote } = this.props;
    // some delay is necessary atm.
    setTimeout(() => {
      if (iframeNote.content && this._iframeRef.current) {
        const blob = base64toBlob(iframeNote.content);
        const pdfContent = URL.createObjectURL(blob);

        const iframeWindow = this._iframeRef.current.contentWindow;

        iframeWindow.postMessage(
          {
            pdfContent: pdfContent
          },
          window.location.origin
        );
      }
    }, 1000);
  }

  render() {
    return (
      <iframe
        className="note-iframe"
        src={`/pages/pdf-viewer/index.html`}
        height="800px"
        min-width="450px"
        ref={this._iframeRef}
      />
    );
  }
}

export { PDFFrame };
